export const routes = [
  {
    path: "/",
    component: () => import("@/views/Menu/MenuPage.vue"),
  },
  {
    path: "/menu/:date",
    component: () => import("@/views/Menu/MenuPage.vue"),
  },
  {
    path: "/admin/login",
    component: () => import("@/views/LoginPage/LoginPage.vue"),
    alias: "/update",
  },
  {
    path: "/admin/calendar",
    component: () => import("@/views/SelectDate/SelectDatePage.vue"),
  },
  {
    path: "/admin/menu/:date/edit",
    component: () => import("@/views/MenuEdit/MenuEditPage.vue"),
  },
];
